import React, { useState } from 'react';
import HistoryCard from './HistoryCard';
import HistoryPageModal from './HistoryPageModal';
import useItems from '../hooks/useItems';
import useWindowLocationHash from '../hooks/useWindowLocationHash';
import disablePageScroll from '../actions/disablePageScroll';
import PropTypes from 'prop-types';
import useModalItemFromHash from '../hooks/useModalItemFromHash';

const HistoryCardsBlock = ({language}) => {

	const [itemsArray, , pagesArray] = useItems('milestones', null, language);
	const [currentModalItemIndex, setCurrentModalItemIndex] = useState(null);
	const [modalIsOpen, setModalIsOpen] = useState(false);
	disablePageScroll(modalIsOpen);
	const [windowLocationHash, setWindowLocationHash] = useWindowLocationHash(itemsArray);
	const [, ] = useModalItemFromHash({
		language,
		itemsArray,
		pagesArray,
		windowLocationHash,
		setCurrentModalItemIndex,
		setModalIsOpen,
	});

	return (
		<>
			{
				itemsArray.length > 0
					&&	<ul className='cards-layout__grid-container'>
						{
							itemsArray.map((item, index) => {
								return <HistoryCard 
									key={item.id}
									title={item.title}
									excerpt={item.excerpt}
									imgSrc={item.image}
									index={index}
									altText={item.alt_text}
									year={item.label}
									itemId={String(item.id)}
									language={language}
									setWindowLocationHash={setWindowLocationHash}
								/>
							})
						}
					</ul>
			} 
			{
				itemsArray.length > 0 && modalIsOpen 
					? <HistoryPageModal
						setModalIsOpen={setModalIsOpen}
						modalContent={itemsArray[currentModalItemIndex]}
						currentModalItemIndex={currentModalItemIndex}
						setCurrentModalItemIndex={setCurrentModalItemIndex}
						modalContentLength={itemsArray.length}
						language={language}
						setWindowLocationHash={setWindowLocationHash}
					/>
					: null
			}
		</>
	)
}

HistoryCardsBlock.propTypes = {
	language: PropTypes.string,
}

export default HistoryCardsBlock;